"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _assets = _interopRequireDefault(require("@insided/deprecated-preact-components//assets"));

/**
 * Renders an icon based on its configuration
 * Eliminates duplication between left and right icon rendering
 */
var renderIcon = function renderIcon(iconConfig) {
  var _iconConfig$customCla;

  return (0, _preact.h)("div", {
    className: "icon-container ".concat((_iconConfig$customCla = iconConfig.customClass) !== null && _iconConfig$customCla !== void 0 ? _iconConfig$customCla : '')
  }, iconConfig.type === 'text' && (0, _preact.h)("span", {
    className: "icon-text"
  }, iconConfig.value), iconConfig.type === 'image' && iconConfig.value, iconConfig.type === 'icon' && iconConfig.iconType && (0, _preact.h)(_assets.default, {
    icon: iconConfig.iconType,
    customClass: iconConfig.customClass
  }));
};
/**
 * Renders a status badge with consistent styling
 */


var renderStatusBadge = function renderStatusBadge(statusBadge) {
  return (0, _preact.h)("span", {
    className: "status-badge status-badge--".concat(statusBadge.type)
  }, statusBadge.text);
};

var AccordionPanelHeader = function AccordionPanelHeader(_ref) {
  var title = _ref.title,
      leftIcon = _ref.leftIcon,
      rightIcon = _ref.rightIcon,
      statusBadge = _ref.statusBadge,
      meta = _ref.meta;
  return (0, _preact.h)("div", {
    className: "panel-header-container"
  }, (0, _preact.h)("div", {
    className: "panel-header-title-wrapper"
  }, (0, _preact.h)("div", {
    className: "panel-header-title"
  }, (0, _preact.h)("div", {
    className: "section-icons"
  }, renderIcon(leftIcon), (0, _preact.h)(_assets.default, {
    icon: "arrowRight",
    customClass: "arrow-icon"
  }), renderIcon(rightIcon)), (0, _preact.h)("span", {
    className: "section-title"
  }, title))), (0, _preact.h)("div", {
    className: "section-icons"
  }, statusBadge && renderStatusBadge(statusBadge), meta));
};

var _default = AccordionPanelHeader;
exports.default = _default;